/**
 * Responsible for combining all fixed label related behaviors and exposing it
 * as a jQuery plugin.
 * @module elements/fields/fixedLabelPlugin
 */
import get from 'lodash/get';
import { createJQueryPlugin } from './form-field-behaviors';
import stateModifiers from './state-modifiers';
import iconifyBehaviors from './iconify-behaviors';
import floatingError from './floating-error';
import togglePassword from './toggle-password';

export const CLEAR_ICON_ATTR = 'data-iconify-clear';

const BLOCK = 'fixed-label';

const getTogglePass = name => get(
  window,
  ['rcProps', 'togglePassword', name],
);

const BUILTIN_BEHAVIORS = [
  stateModifiers(),
  iconifyBehaviors({
    containerClassName: `${BLOCK}__iconify`,
  }),
  floatingError({
    floatingErrorContainerClassName: `${BLOCK}--floating-error`,
    floatingErrorClassName: `${BLOCK}__error`,
  }),
  togglePassword({
    actionClassName: `${BLOCK}__toggle-password`,
    fieldAttrs: {
      'data-iconify-disable-clear': true,
    },
    showText: getTogglePass('showText'),
    hideText: getTogglePass('hideText'),
    a11yShowText: getTogglePass('a11yShowText'),
    a11yHideText: getTogglePass('a11yHideText'),
  }),
];


export default createJQueryPlugin('fixedLabel', BLOCK, BUILTIN_BEHAVIORS, (el, options) => {
  if (!el.dataset.iconifyDisableClear) {
    el.setAttribute(CLEAR_ICON_ATTR, 'Clear');
  }

  return Object.assign({}, options);
});


// WEBPACK FOOTER //
// ./styleguide/src/assets/elements/fields/fixed-label-plugin.js